export enum TasksBlockType {
    OVERDUE = 'outdated',
    IN_PROCESS = 'in_progress',
    TODAY = 'today',
    IN_WEEKS = 'seven_days',
    NO_TERM = 'no_term',
}
